<template>
  <div>
    <Loader :loading='loading' />
    <div class="container">
      <VideoPlayer 
        :src="videoLink" 
        :title='article.title'
        :id='article.episode_id'
        :time='time'
        type='tvshow'
        v-if="!loading"
        :rating='article.rating'
        :genre='article.genre'
        :description='article.description'
        :update-play-time='true'
        :thumbnail='article.avatar'
        :playlist='episodes'
        playlist-title='All Episodes'
      />
    </div>
  </div>  
</template>

<script>
import VideoPlayer from '../components/VideoPlayer'
import Loader from "../components/Loader";
import { authRequest, log } from '../app/helpers';

export default {

  components: {
    VideoPlayer,
    Loader
  },

  data() {
    return {
      loading: true,
      videoLink: null,
      time: null,
      article: {},
      episodes: []
    }
  },

  mounted() {
    this.$store.commit('bodyClass', 'tvshow-play play-page')
    
    this.fetch();
  },

  methods: {
    async fetch() {
      this.loading = true;

      const req = await authRequest(
        this.$router,
        '/tv-show/episode/' + this.$route.params.id + '/play',
      );

      if (!req) {
        return null;
      }

      this.videoLink = req.video.google_link
      this.article = req.video
      this.time = req.time
      this.loading = false;
      const episodes = req.episodes;

      let epArr = [];

      if (episodes) {
        for (const e in episodes) {
          epArr.push({
            title: episodes[e].title,
            thumbnail: episodes[e].avatar,
            description: episodes[e].description,
            url: '/tv-show/' + episodes[e].episode_id + '/play'
          });
        }
      }
      
      log(epArr);
      this.episodes = epArr;
    },
  },

  watch: {
    $route() {
      this.fetch();
    }
  }
}
</script>

<style scoped>
</style>